import cx from 'classnames';
import { linebreaksbr } from 'mk/bazaar/common/filters';
import { TextLike } from 'mk/bazaar/common/filters/utils';
import { linkize } from 'mk2/apps/strollers/utils';
import React from 'react';
import styles from './CollapsedTextBox.mscss';

interface OwnState {
    collapsed: boolean;
}

interface OwnProps {
    height: number;
    expandText: string;
    text: TextLike;
    className?: string;
}

type Props = OwnProps;

export class CollapsedTextBox extends React.Component<Props, OwnState> {

    public static defaultProps: Partial<OwnProps> = {
    };

    private paragraph: HTMLElement;

    constructor(props: Props) {
        super(props);

        this.state = {
            collapsed: false,
        };
    }

    public componentDidMount() {
        this.collapseIfNeeded();
    }

    public componentDidUpdate(prevProps, prevState) {
        if (prevProps.text !== this.props.text) {
            this.collapseIfNeeded();
        }
    }

    public render() {
        const { className, expandText, height, text } = this.props;

        const processedText = text ? linebreaksbr(linkize(text)) : null;

        return (
            <div style={(this.state.collapsed) ? {height: height + 'px'} : null} className={cx(styles.CollapsedTextBox, className, (!this.state.collapsed) ? styles.CollapsedTextBox__collapsed : null)}>
                <div ref={(e) => this.paragraph = e} className={styles.CollapsedTextBox__text}>
                    {processedText}
                    {this.props.children}
                </div>
                {(this.state.collapsed) ? (
                    <a
                        data-google-interstitial="false"
                        href="#"
                        className={styles.CollapsedTextBox__expand}
                        onClick={this.onCollapseOpen}
                    >
                        <b />
                        <span>{expandText}</span>
                    </a>
                ) : null}
            </div>
        );
    }

    private collapseIfNeeded = () => {
        if ((this.paragraph.offsetHeight) && (this.paragraph.offsetHeight > (this.props.height + 20))) {
            this.setState({collapsed: true});
        }
    };

    private onCollapseOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        this.setState({ collapsed: false });
    };
}
